import {DeliveryAddress} from 'utilities/location';

import styles from './FormattedAddress.css';

interface Props {
  address?: DeliveryAddress | null;
  truncate?: boolean;
}

export function FormattedAddress({address, truncate = false}: Props) {
  const fallbackAddress = 'United States';

  if (!truncate && address?.city && address.zip) {
    const addressContent = `${address.city.trim()} ${address.zip}`;
    return <span className={styles.underline}>{addressContent}</span>;
  }

  if (!truncate && address?.city) {
    return (
      <span className={styles.address}>
        <span className={styles.underline}>{address.city.trim()}</span>
      </span>
    );
  }

  if (address?.zip) {
    return (
      <span className={styles.address}>
        <span className={styles.underline}>{address.zip}</span>
      </span>
    );
  }

  return (
    <span className={styles.address}>
      <span className={styles.underline}>{fallbackAddress}</span>
    </span>
  );
}
